export default "__VITE_ASSET__e0e27bb8__"